import { z } from "zod";

export const Jwk = z
  .object({
    kty: z.literal("EC"),
    crv: z.literal("P-256"),
    x: z.string(),
    y: z.string(),
    kid: z.string(),
    use: z.literal("sig"),
    alg: z.literal("ES256"),
  })
  .meta({ id: "Jwk" });

export const Jwks = z.object({ keys: z.array(Jwk) }).meta({ id: "Jwks" });
export type Jwks = z.infer<typeof Jwks>;
